import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MedReviewService } from '../../services/med-review.service';

@Component({
  selector: 'kt-medication-history',
  templateUrl: './medication-history.component.html',
  styleUrls: ['./medication-history.component.scss'],
})
export class MedicationHistoryComponent implements OnInit {
  private medication: any;
  compareKeys = [
    {
      key: 'dose',
      label: 'Dose',
    },
    {
      key: 'frequency',
      label: 'Frequency',
    },
    {
      key: 'hoa',
      label: 'HOA',
    },
    {
      key: 'hold',
      label: 'Hold',
    },
    {
      key: 'med_type',
      label: 'Med type',
    },
    {
      key: 'rx',
      label: 'Rx',
    },
    {
      key: 'office',
      label: 'Office',
    },
    {
      key: 'prev_tran',
      label: 'Pre Tran',
    },
    {
      key: 'pms_rx',
      label: 'PMS Rx',
    },
    {
      key: 'status',
      label: 'Status',
    },
  ];
  histories: any = [];
  numOfHistories = 0;
  private patientId: number;

  constructor(
    public dialogRef: MatDialogRef<MedicationHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private medReviewService: MedReviewService,
  ) {
    this.medication = this.data.medication;
    if (!this.medication.hicl) {
      const newObj = Object.assign({ hicl: this.medication.hicl_seqno }, this.medication);
      this.medication = newObj;
    }
    this.patientId = this.medReviewService.currentMedReviewPatientId;
  }

  ngOnInit(): void {
    this.histories = [];
    this.medReviewService
      .getMedicationHistoryByPatientAndHicl(this.patientId, this.medication.hicl)
      .subscribe((res: []) => {
        this.fillHistory(res);
      });
  }

  private fillHistory(res) {
    res.forEach((history: any) => {
      const o = {
        date: history.created,
        list: [],
      };
      let primaryChanged = 0;
      this.compareKeys.forEach((key) => {
        // tslint:disable-next-line:triple-equals
        if (
          history['current_' + key.key] != history['old_' + key.key] &&
          (!!history['current_' + key.key] || !!history['old_' + key.key])
        ) {
          o.list.push({
            old: history['old_' + key.key],
            current: history['current_' + key.key],
            label: key.label,
          });
          primaryChanged++;
        }
      });
      if (primaryChanged !== 0) {
        this.numOfHistories++;
        this.histories.push(o);
      }
    });
    this.histories = this.histories.reverse();
  }
}
